import {getUsuarioLogado} from "../../../util";
import {
    IconMail,
    IconPower,
    IconTag,
    IconUser
} from '@tabler/icons-react';
import {Center, Group, Menu, rem, Text, UnstyledButton} from '@mantine/core';
import React from 'react';


export default function MenuUsuario() {
    const usuarioLogado = getUsuarioLogado()

    function sair() {
        localStorage.clear();
        window.location.assign("/")
    }

    return (
        <Menu shadow="md">
            <Menu.Target>
                <UnstyledButton>
                    <Group visibleFrom="sm">
                        <IconUser size="1.5rem" />
                        <div style={{ flex: 1 }}>
                            <Text size="sm" fw={500}>
                                {usuarioLogado.username}
                            </Text>

                            <Text c="dimmed" size="xs">
                                {usuarioLogado.email}
                            </Text>
                        </div>
                    </Group>
                </UnstyledButton>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Label>Menu Usuário</Menu.Label>
                <Menu.Item leftSection={<IconUser style={{ width: rem(14), height: rem(14) }} />}>
                    {usuarioLogado.nome}
                </Menu.Item>
                <Menu.Item leftSection={<IconMail style={{ width: rem(14), height: rem(14) }} />}>
                    {usuarioLogado.email}
                </Menu.Item>
                <Menu.Item leftSection={<IconTag style={{ width: rem(14), height: rem(14) }} />}>
                    {usuarioLogado.setor?.nome}
                </Menu.Item>

                <Menu.Divider />

                <Menu.Label>Sair</Menu.Label>
                <Menu.Item onClick={sair}>
                    <Center>
                        <IconPower /> <Text component={"span"} ml={5}>Sair do Sistema</Text>
                    </Center>
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
}
